/**
 * This file is part of the Valkyrie Robotics public website.
 * © 2025 Valkyrie Robotics, LLC. All rights reserved.
 */

import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles.css";
import { AppShell } from "./shell/AppShell";
import { HomePage } from "./pages/HomePage";
import { IQPage } from "./pages/IQPage";
import { V5Page } from "./pages/V5Page";
import { SummerCampPage } from "./pages/SummerCampPage";

import { ContactPage } from "./pages/ContactPage";
import { ThankYouPage } from "./pages/ThankYouPage";
import { BlogIndexPage } from "./pages/BlogIndexPage";
import { BlogPostPage } from "./pages/BlogPostPage";
import { AboutPage } from "./pages/AboutPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPage } from "./pages/PrivacyPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AppShell>
        <HomePage />
      </AppShell>
    ),
  },
  {
    path: "/about",
    element: (
      <AppShell>
        <AboutPage />
      </AppShell>
    ),
  },
  {
    path: "/terms",
    element: (
      <AppShell>
        <TermsPage />
      </AppShell>
    ),
  },
  {
    path: "/privacy",
    element: (
      <AppShell>
        <PrivacyPage />
      </AppShell>
    ),
  },
  {
    path: "/iq",
    element: (
      <AppShell>
        <IQPage />
      </AppShell>
    ),
  },
  {
    path: "/v5",
    element: (
      <AppShell>
        <V5Page />
      </AppShell>
    ),
  },
  {
    path: "/summer-camp",
    element: (
      <AppShell>
        <SummerCampPage />
      </AppShell>
    ),
  },

  {
    path: "/contact",
    element: (
      <AppShell>
        <ContactPage />
      </AppShell>
    ),
  },
  {
    path: "/thank-you",
    element: (
      <AppShell>
        <ThankYouPage />
      </AppShell>
    ),
  },
  {
    path: "/blog",
    element: (
      <AppShell>
        <BlogIndexPage />
      </AppShell>
    ),
  },
  {
    path: "/blog/:slug",
    element: (
      <AppShell>
        <BlogPostPage />
      </AppShell>
    ),
  },
  {
    path: "*",
    element: (
      <AppShell>
        <NotFoundPage />
      </AppShell>
    ),
  },
]);

const container = document.getElementById("root")!;
createRoot(container).render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);
